import { render, staticRenderFns } from "./BadgeManagementModal.vue?vue&type=template&id=38796280&"
import script from "./BadgeManagementModal.vue?vue&type=script&lang=js&"
export * from "./BadgeManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./BadgeManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BadgeManagementModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/BadgeManagementModal.vue
// module id = 2324
// module chunks = 1